import { trackError } from '@web/utils/datadog';

/** Logs to the console and reports the error to Datadog RUM (Error Tracking) when the SDK is running. */
export const logError = (error: Error): void => {
  console.error('ERROR: logError ->', error);
  trackError(error, { origin: 'web.utils/error' });
};
